export const searchApi = (KeyWord) => {
  // eslint-disable-next-line max-len
  return `https://ec.europa.eu/info/funding-tenders/opportunities/portal/screen/how-to-participate/partner-search;searchKeyword=${KeyWord};isOrganisation=true;isPerson=true;topics=;programmes=;organisationType=;country=;city=;professionalProfile=;hasPartnerSearch=false;type=ORGANISATION,PERSON;orderBy=;sortQuery=;date=1653919708524`;
};
